import CheckCircleIcon from '../Icon/CheckCircleIcon.js';
import ErrorIcon from '../Icon/ErrorIcon.js';
import InfoIcon from '../Icon/InfoIcon.js';
import QuestionCircleIcon from '../Icon/QuestionCircleIcon.js';
import WarningIcon from '../Icon/WarningIcon.js';

//
var script = {
  components: {
    InfoIcon,
    WarningIcon,
    ErrorIcon,
    'confirmation-icon': CheckCircleIcon,
    'change-icon': QuestionCircleIcon
  },
  props: {
    title: {
      type: String,
      default: undefined
    },
    appearance: {
      type: String,
      default: 'info',
      validator: value => ['info', 'warning', 'error', 'confirmation', 'change'].includes(value)
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/SectionMessage/SectionMessage.vue_rollup-plugin-vue=script.js